import { render, staticRenderFns } from "./assurance_section.vue?vue&type=template&id=5469beec&scoped=true"
import script from "./assurance_section.vue?vue&type=script&lang=js"
export * from "./assurance_section.vue?vue&type=script&lang=js"
import style0 from "./assurance_section.vue?vue&type=style&index=0&id=5469beec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5469beec",
  null
  
)

export default component.exports